// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryTitleAndDescription_root__klbFh","rootSearch":"CategoryTitleAndDescription_rootSearch__tIuHV","subtitle":"CategoryTitleAndDescription_subtitle__vMIKw"};